import React from "react";

function FileIconGray() {
    return (
        <>
            <span className="site-icons icon-pdf"></span>
        </>
    )
}
export default FileIconGray;